/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBootVolumeBackup = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M2 2h20v20H2V2zm2 2v16h16V4H4zm3 3.101V6H5v5h5V9H8a5.002 5.002 0 0 1 8.932 2.165l1.971-.33A7.002 7.002 0 0 0 7 7.1zM11 8h2v2.613l1.684-.562.632 1.898L11 13.387V8zm-3.93 4.835A5.002 5.002 0 0 0 16 15h-2v-2h5v5h-2v-1.101a7.002 7.002 0 0 1-11.903-3.733l1.972-.332z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgBootVolumeBackup as BootVolumeBackup };
